import { useState } from 'react';
import { getCookie } from 'utils';
import {
  SUPER_USER_IDS,
  TRANSCRIPT_ANNOTATION_ALLOWED_USERS,
  SALES_PITCH_ALLOWED_USERS,
  REGULAR_CLASS_ALLOWED_USERS,
} from 'constants/trial-db-permissions';

export const useTrialPermissions = () => {
  const [userId] = useState(() => {
    const cookieUserId = getCookie('user_id') || getCookie('emp_id');
    // For dev: fallback to hardcoded user ID when cookie is not available
    return cookieUserId || '1bfd0c1e-ec95-11e8-9b4a-02420a0000e2';
  });

  // For dev: hardcoded super user check
  const isSuperUser =
    userId === '1bfd0c1e-ec95-11e8-9b4a-02420a0000e2' || SUPER_USER_IDS.includes(userId);

  return {
    canGenerateTranscript:
      isSuperUser || TRANSCRIPT_ANNOTATION_ALLOWED_USERS.includes(userId),
    canCreateAnnotation:
      isSuperUser || TRANSCRIPT_ANNOTATION_ALLOWED_USERS.includes(userId),
    canGenerateSalesPitch: isSuperUser || SALES_PITCH_ALLOWED_USERS.includes(userId),
    canViewRegularClasses: isSuperUser || REGULAR_CLASS_ALLOWED_USERS.includes(userId),
    isSuperUser,
    userId,
  };
};
